import { $$Whole } from "../../../helpers";
import { medigapPlans, MedigapPlanType } from "./plans";

export const getMedigapPriceRange = (min: number, max: number): string => {
  const minWhole = Math.round(min);
  const maxWhole = Math.round(max);

  return minWhole === maxWhole
    ? $$Whole(minWhole)
    : `${$$Whole(minWhole)}-${$$Whole(maxWhole)}`;
};

export const getNonWaiverPlan = ({
  pricingYear,
  medigapPlanType,
}: {
  pricingYear: string;
  medigapPlanType: MedigapPlanType;
}) => {
  const plans = medigapPlans[pricingYear]?.nonWaiver || [];
  return plans.find(plan => plan.plan_type === medigapPlanType);
};
